export default __webpack_public_path__ + "static/media/m_use_action_hk.ac911ef9.png";